import React from "react";
import ModalImport from "../../../components/ModalImport/ModalImport";
import ModalMutasiStok from "../../../components/ModalMutasiStok/ModalMutasiStok";
import ModalKatalog from "../../../components/ModalKatalog/ModalKatalog";
import ModalKategori from "../../../components/ModalKategori/ModalKategori";
import ModalPrintBarcode from "../../../components/ModalPrintBarcode/ModalPrintBarcode";
import ModalEditKategori from "../../../components/ModalEditKategori/ModalEditKategori";
import ModalDeleteKategori from "../../../components/ModalDeleteKategori/ModalDeleteKategori";

interface StokBarangModalsProps {
    deleteKategoriState: {
        open: boolean;
        id: number | string | undefined;
        nama: string;
    };
    editKategoriState: {
        open: boolean;
        id: number | string | undefined;
        nama: string;
    };
    isModalImportOpen: boolean;
    isModalKatalogOpen: boolean;
    isModalKategoriOpen: boolean;
    isModalMutasiOpen: boolean;
    namaToko?: string;
    onCloseDeleteKategori: () => void;
    onCloseEditKategori: () => void;
    onCloseImport: () => void;
    onCloseKatalog: () => void;
    onCloseKategori: () => void;
    onCloseMutasi: () => void;
    onClosePrintBarcode: () => void;
    onOpenDeleteKategori: (id: number | string, nama: string) => void;
    onOpenEditKategori: (id: number, nama: string) => void;
    onOpenKategori: () => void;
    printBarcodeState: {
        open: boolean;
        sku?: string | null;
        namaBarang: string;
        hargaBarang: string;
    };
    refetchKategori: () => void;
    ukmIsPro?: number;
}

const StokBarangModals = ({
    deleteKategoriState,
    editKategoriState,
    isModalImportOpen,
    isModalKatalogOpen,
    isModalKategoriOpen,
    isModalMutasiOpen,
    namaToko,
    onCloseDeleteKategori,
    onCloseEditKategori,
    onCloseImport,
    onCloseKatalog,
    onCloseKategori,
    onCloseMutasi,
    onClosePrintBarcode,
    onOpenDeleteKategori,
    onOpenEditKategori,
    onOpenKategori,
    printBarcodeState,
    refetchKategori,
    ukmIsPro,
}: StokBarangModalsProps) => {
    return (
        <>
            {isModalKategoriOpen && (
                <ModalKategori
                    refetch={refetchKategori}
                    open={isModalKategoriOpen}
                    onClose={onCloseKategori}
                    onOpenDelete={onOpenDeleteKategori}
                    onOpenEdit={onOpenEditKategori}
                />
            )}
            {deleteKategoriState.open && (
                <ModalDeleteKategori
                    refetch={refetchKategori}
                    open={deleteKategoriState.open}
                    onClose={onCloseDeleteKategori}
                    kategoriName={deleteKategoriState.nama}
                    kategoriId={deleteKategoriState.id}
                    onBackToKategori={onOpenKategori}
                />
            )}
            {editKategoriState.open && (
                <ModalEditKategori
                    refetch={refetchKategori}
                    open={editKategoriState.open}
                    onClose={onCloseEditKategori}
                    kategoriName={editKategoriState.nama}
                    kategoriId={editKategoriState.id}
                    onBackToKategori={onOpenKategori}
                />
            )}
            {isModalKatalogOpen && (
                <ModalKatalog
                    namaUkm={namaToko}
                    open={isModalKatalogOpen}
                    onClose={onCloseKatalog}
                />
            )}
            {isModalImportOpen && (
                <ModalImport
                    namaToko={namaToko}
                    isPro={ukmIsPro}
                    open={isModalImportOpen}
                    onClose={onCloseImport}
                />
            )}
            {isModalMutasiOpen && (
                <ModalMutasiStok
                    open={isModalMutasiOpen}
                    onClose={onCloseMutasi}
                />
            )}
            {printBarcodeState.open && (
                <ModalPrintBarcode
                    open={printBarcodeState.open}
                    onClose={onClosePrintBarcode}
                    sku={printBarcodeState.sku}
                    namaBarang={printBarcodeState.namaBarang}
                    hargaBarang={printBarcodeState.hargaBarang}
                />
            )}
        </>
    );
};

export default StokBarangModals;
